export default "__VITE_ASSET__Bst1xhr8__"